import { render } from "./TeachingPlanMiniGrid.vue?vue&type=template&id=25c8dd4f&scoped=true&ts=true"
import script from "./TeachingPlanMiniGrid.vue?vue&type=script&lang=ts"
export * from "./TeachingPlanMiniGrid.vue?vue&type=script&lang=ts"

import "./TeachingPlanMiniGrid.vue?vue&type=style&index=0&id=25c8dd4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c8dd4f"]])

export default __exports__